import { z } from 'zod';

export const accountSchema = z.object({
  id: z.number().min(1),
  name: z.string().min(1),
  alias: z.string(),
});

export const accountsSchema = z.array(accountSchema);

export type Account = z.infer<typeof accountSchema>;

export type Accounts = z.infer<typeof accountsSchema>;
